namespace $ { $mol_style_attach( "milis/skills/skills.view.css",
 "[mol_book2] > *:not(:first-of-type):before,\n[mol_book2] > *:not(:last-of-type)::after {\n\twidth: 6px;\n}\n"
) }